import React, { FC } from 'react'
import { AppAvatar } from './AppAvatar'
import { Typography } from '@mui/material'

interface AvatarAndNameProps {
	avatarSrc?: string
	gender?: string
	name: string
	avatarWidth?: number
	avatarHeight?: number
	avatarStyle?: object
}

const AvatarAndName: FC<AvatarAndNameProps> = ({
	avatarSrc,
	gender,
	name,
	avatarWidth = 20,
	avatarHeight = 20,
	avatarStyle,
}: AvatarAndNameProps) => {
	return (
		<>
			<AppAvatar
				avatar={avatarSrc || ''}
				alt={'patient'}
				gender={gender}
				style={{
					position: 'relative',
					marginRight: '0.5rem',
					...avatarStyle,
				}}
				width={avatarWidth}
				height={avatarHeight}
			/>

			<Typography fontSize={'0.875rem'}>{name}</Typography>
		</>
	)
}

export default AvatarAndName
